import { IApiService } from '../services/api_service';

export const inmateContact = (siteApi: IApiService, centralApi: IApiService) => ({
  index: (params) => {
    return siteApi.get('/inmate-contact', { params });
  },
  post: (data) => {
    return centralApi.post('/inmate-contact', data);
  },
  put: (id, data) => {
    return centralApi.put(`/inmate-contact/by-id/${id}`, data);
  }
});
